// src/components/Charts/pie/MostUsedCptsPieChart.jsx
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AnalyticsPieCard from './AnalyticsPieCard';
import { BASE_PIE_COLORS, OTHERS_COLOR } from '../../../constants/ColorsPalette';
import { urls } from '../../config/variables';
import AppContext from '../../../contexts/app-context';
import AuthContext from '../../../contexts/auth-context';

export default function MostUsedCptsPieChart({ chartId }) {
  const { t } = useTranslation('analytics');
  useContext(AppContext);
  useContext(AuthContext);

  return (
    <AnalyticsPieCard
      chartId={chartId}
      endpoint={urls.CPTS_COUNT}
      i18n={{
        seriesName: t('MostUsedCPTs') || 'Most Used CPTs',
        centerLabel: t('CPTs') || 'CPTs',
        detailsButton: 'CPTs Details',
        dialogTitle: 'All CPTs',
        entityName: 'CPT Code',
        noData: t('NoData') || 'No data',
      }}
      nameKeys={['cpt_code', 'code']}
      valueKeys={['cpt_count', 'count']}
      parseResponse={(data) => {
        if (Array.isArray(data)) return { rows: data };
        if (data && Array.isArray(data.most_used_cpts)) return { rows: data.most_used_cpts };
        console.error('Unexpected response shape for MostUsedCpts:', data);
        return { rows: [] };
      }}
      baseColors={BASE_PIE_COLORS}
      othersColor={OTHERS_COLOR}
      othersLabel="Others"
      topN={14}
    />
  );
}